import { useState } from "react";
import { Upload } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

export function ImageUploader({ value, onChange, testid = "img" }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true); setErr("");
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } catch {
      setErr("Upload failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-3">
      {value ? (
        <img src={mediaUrl(value)} alt="" className="w-16 h-16 object-cover border border-[#E5E5DF] flex-shrink-0" />
      ) : (
        <div className="w-16 h-16 bg-[#F1EFE8] border border-[#E5E5DF] flex-shrink-0" />
      )}
      <input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Paste image URL or upload"
        className="input-lux !py-1 text-sm flex-1"
        data-testid={`${testid}-url`}
      />
      <label className="btn-outline-dark !py-2 !px-4 cursor-pointer text-xs whitespace-nowrap" data-testid={`${testid}-upload`}>
        <Upload size={14} className="mr-1" /> {busy ? "…" : "Upload"}
        <input type="file" accept="image/*,video/*" className="hidden" onChange={upload} />
      </label>
      {err && <span className="text-xs text-red-600">{err}</span>}
    </div>
  );
}
